<template>
  <v-container>
    <h1>{{ $store.getters.dictionaryName }} / Words</h1>
    <TranslationsTable v-on:edit="edit($event)" v-on:create="create"></TranslationsTable>
    <TranslationDialog v-model="dialog" :model="model" v-on:next="next($event)"></TranslationDialog>
  </v-container>
</template>

<script>
import TranslationsTable from '../components/TranslationsTable'
import TranslationDialog from '../components/TranslationDialog'
import { NEXT_TRANSLATION } from '../store/action-types'

export default {
  components: { TranslationDialog, TranslationsTable },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    create () {
      this.model = null
      this.dialog = true
    },
    edit (model) {
      this.model = model
      this.dialog = true
    },
    async next (model) {
      try {
        const nextModel = await this.$store.dispatch(NEXT_TRANSLATION, { translation: model })
        if (nextModel) {
          this.dialog = false
          setTimeout(() => { // TranslationDialog завязан, что вместе с изменением слова диалог должен переоткрываться
            this.dialog = true
            this.model = nextModel
          }, 500)
        } else {
          this.dialog = false
          this.model = null
        }
      } catch (e) {
        alert(e)
        console.error(e)
      }
    }
  }
}
</script>
